import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FormGroup, FormBuilder, Validators   } from '@angular/forms';
import { AuthService } from '../../../system/auth.service';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../tabconfig/tab.service';

import { DialogService } from '../../../common/dialog.service';

import { FileUploader } from 'ng2-file-upload';
import { BASE_URL_UPLOAD } from '../../../app.service';
import { AssignFilesCoursesService } from '../../../api/Services/maintenance/assign-files-courses.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FileViewerComponent } from '../../common/file-viewer/file-viewer.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MovieViewerVimeoComponent } from '../../common/movie-viewer-vimeo/movie-viewer-vimeo.component';


@Component({
  selector: 'app-assign-files-course',
  templateUrl: './assign-files-course.component.html',
  styleUrls: ['./assign-files-course.component.css']
})
export class AssignFilesCourseComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  public parameters: any[];
  public seleted_file_type: string;
  @Input() cou_in_id;
  @Input() cou_vc_uri_folder;

  public editActivo = false;
  public displayedColumns: string[] = ['asfico_vc_file_type', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;


  ContentAssingFileCourses: FormGroup;
  uploader: FileUploader;
  response: string;
  bLink:Boolean = false;
  asfico_vc_file_name:string;
  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private assignFilesCourses: AssignFilesCoursesService

  ) {

    this.uploader = new FileUploader({
      url: BASE_URL_UPLOAD,
      itemAlias: 'file',
      disableMultipart: false,
      autoUpload: false,
      method: 'post' //,
      //allowedFileType: ['image', 'pdf']
    });

    this.uploader.response.subscribe(res => this.response = res);

  }

  ngOnInit(): void {
    this.initForm();
    this.LoadInitial();
    this.seleted_file_type = "";

    this.GetAll();

    this.uploader.onAfterAddingFile = (file) => {
      console.log('Uploaded onAfterAddingFile:', file);
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (item: any, status: any) => {

      let obj = JSON.parse(status);
      if (obj["success"]) {
        let link = obj["data"]

        this.ContentAssingFileCourses.controls['asfico_vc_file'].setValue(link.filename);
        this.ContentAssingFileCourses.controls['asfico_vc_file_name'].setValue(link.filename);
        this.ContentAssingFileCourses.controls['cou_in_id'].setValue(this.cou_in_id);
        this.ContentAssingFileCourses.controls['cou_vc_uri_folder'].setValue(this.cou_vc_uri_folder);

        this.Save();
      }
      else {
        this.toastr.warning('hubo un error al intentar subir este archivo', 'Advertencia');
      }
    };
  }

  public initForm() {
    this.ContentAssingFileCourses = this.formBuilder.group({
      asfico_bi_id: [null],
      cou_in_id: [null, Validators.required],
      asfico_in_file_type: [null, Validators.required],
      asfico_vc_file: [null, Validators.required],
      asfico_vc_file_name: [null, Validators.required] ,
      cou_vc_uri_folder:[null]
    });

  }

  LoadInitial() {
    this.parameters = this.authService.getParameters();
  }


  Register() {


      this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
        .afterClosed().subscribe(res => {
          if (res) {

            if(this.bLink){

              console.log(this.ContentAssingFileCourses.controls['asfico_vc_file_name'].value);
              this.ContentAssingFileCourses.controls['asfico_vc_file'].setValue(this.ContentAssingFileCourses.controls['asfico_vc_file_name'].value);

              this.ContentAssingFileCourses.controls['cou_in_id'].setValue(this.cou_in_id);
              this.ContentAssingFileCourses.controls['cou_vc_uri_folder'].setValue(this.cou_vc_uri_folder);

              this.Save();
            }
            else{
              this.uploader.uploadAll();
            }
          }
        });



  }
  Save() {


    this.assignFilesCourses.Insert(this.ContentAssingFileCourses.getRawValue()).subscribe(
      data => {

        if (data['sucess']) {
          this.editActivo = false;
          let result = data['data'][0];
          this.uploader.clearQueue();
          this.GetAll();
          this.toastr.success(data['msg'], 'Correcto');
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }
      }
    );


  }
  Detele(asfico_bi_id: number) {
    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.assignFilesCourses.Delete(asfico_bi_id).subscribe(
            data => {
              if (data['sucess']) {

                this.GetAll();
                this.toastr.success(data['msg'], 'Correcto');

              }
              else {
                this.toastr.warning(data['msg'], 'Advertencia');
              }


            }
          );
        }
      });
  }

  GetAll(){

    this.assignFilesCourses.GetAll(this.cou_in_id).subscribe(
      data => {
        if (data['sucess']) {

          this.dataSource = new MatTableDataSource<any[]>(data["data"]);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;


        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }


      }
    );
  }

  viewerFile(element){
    const dialogConfig = new MatDialogConfig();


    if (element.asfico_in_file_type == 4) {


      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.data = element.asfico_vc_file_html;
      dialogConfig.minWidth = '40%';

      const dialogRef = this.dialog.open(MovieViewerVimeoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });


    }
    else {

      if(element.asfico_in_file_type==5){
        window.open(element.asfico_vc_file_html, '_blank');
      }
      else{

        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = { action: 1, type:  element.asfico_in_file_type, link: element.asfico_vc_file };
        dialogConfig.minWidth = '50%';

        const dialogRef = this.dialog.open(FileViewerComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
          console.log(`Dialog result: ${result}`);
        });
      }




    }


  }
  onChange(value:number){

    if(value!=null){
      if(value>0){
         if(value==5){
           this.bLink = true;
         }
         else{
          this.bLink = false;
         }
      }
      else{
        this.bLink = false;
      }
    }
    else{
      this.bLink = false;
    }
  }
}
